import { render } from "./pb-donors.vue?vue&type=template&id=148e8b88"
import script from "./pb-donors.vue?vue&type=script&lang=js"
export * from "./pb-donors.vue?vue&type=script&lang=js"

import "./pb-donors.vue?vue&type=style&index=0&id=148e8b88&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__